import { Helmet } from "react-helmet";
import MapLayout from "../sections/map/mapLayout";
import BottomNavigationComponent from "../components/navigation/bottomNavigationComponent";
import WebNavigationComponent from "../components/navigation/webNavigationComponent";

const navOption = 1;

const MapPage = () => {
    <Helmet>
        <title>Map</title>
    </Helmet>

    return(
        <>
            <WebNavigationComponent defaultIndex={navOption}/>
            
            <MapLayout />
            
            <BottomNavigationComponent defaultIndex={navOption}/>
        </>
    );
}

export default MapPage;